import { useState, useCallback, useEffect } from "react";
import { IBOInfo } from "Membership/LookupByIBO/useIBOInfo";
import EditableText from "shared/@forms/EditableText";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import createNotification from "shared/@utils/createNotification";

export default function UsernameEdit({ onChange }) {
  const { logError } = useLogger({ prefix: "UsernameEdit" });

  const { hasPermission, makeAuthedRequest } = Auth.useContainer();
  const { iboInfo, refreshIBOInfo } = IBOInfo.useContainer();

  const { iboNumber, username } = iboInfo.primaryInfo;

  const [fieldValue, setFieldValue] = useState(iboInfo.primaryInfo.username);

  useEffect(() => {
    setFieldValue(username);
  }, [username]);

  const canUpdate = hasPermission("membership.ibo.update");

  const updateUsername = useCallback(
    async (newUsername) => {
      setFieldValue(newUsername);

      return makeAuthedRequest(`/v1/membership/ibo/${iboNumber}`, {
        method: "PUT",
        body: JSON.stringify({ username: newUsername }),
      })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const json = await res.json();
            throw new Error(json.message);
          }
        })
        .then(() => {
          refreshIBOInfo();
          createNotification({
            type: "success",
            title: "Username Updated",
            message: `IBO's username has been changed to '${newUsername}'.`,
            autoDismiss: true,
          });
        })
        .catch((err) => {
          logError(err);
          setFieldValue(username);
        });
    },
    [iboNumber, username, logError, refreshIBOInfo]
  );

  if (canUpdate) {
    return <EditableText value={fieldValue} onChange={updateUsername} />;
  } else {
    return <span>{username}</span>;
  }
}
